'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { LayoutContainerMods } from '~components/LayoutContainer/LayoutContainer.types';
import { useBreakpoints } from '~hooks/useBreakpoints';
import { ThemesNames } from '~types/Theme.types';
import { URLS } from '~types/Urls.types';

import styles from './AnchorMenu.module.scss';
import { AnchorMenuProps } from './AnchorMenu.types';

export const AnchorMenu = ({
  className,
  items,
  mod = ThemesNames.White,
  menuRef,
}: AnchorMenuProps) => {
  const [currentPath, setCurrentPath] = useState<string>('');
  const [, { isMobile }] = useBreakpoints();
  const pathname = usePathname();
  useEffect(() => {
    setCurrentPath(pathname);
  }, [pathname]);
  return (
    <nav
      className={classNames(styles.anchorMenu, styles[mod], className)}
      ref={menuRef}
    >
      <LayoutContainer
        mods={
          isMobile
            ? [LayoutContainerMods.PaddingNone]
            : [LayoutContainerMods.Inner]
        }
      >
        <ul className={styles.list}>
          <li
            key="mainUrl"
            className={classNames(styles.listItem, {
              [styles.active]: currentPath?.match(/^\/blog\/?$/),
            })}
          >
            <Link href={URLS.Blog} className={styles.listItemLink}>
              Главная
            </Link>
          </li>
          {items?.map((item) => (
            <li
              key={item.id}
              className={classNames(styles.listItem, {
                [styles.active]: currentPath
                  ? currentPath.includes(item.slug)
                  : false,
              })}
            >
              <Link
                href={`${URLS.BlogCategory}/${item.slug}/`}
                className={styles.listItemLink}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </LayoutContainer>
    </nav>
  );
};
